export default () => ({
  newsItems: null,
  loading: false,
  editingNewsItem: null,
  paginator: { page: 0, size: 0, total: 0, loadingPage: null },
  sort: { field: "createdOn", order: "desc" },
});
